/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      service — thin app-level subclass of the shared intl service
 *              (locale/translation), so the app has its own registrable
 *              `service:intl`
 *   extends:   IntlService (beebee-base/services/intl) (addon)
 *   template:  none
 *   key:       (none added here — inherits the full API from the beebee-base
 *              IntlService)
 *   uses:      beebee-base/services/intl
 *   siblings:  -
 *   tests:     none
 *   gotchas:   subclassing the real beebee-base IntlService throws without a
 *              configured locale, and registering a test double via
 *              `owner.register('service:intl', ...)` does not take effect on
 *              every codepath — tests instead shadow the instance's `.intl`
 *              directly (see tests/unit/routes/simple-routes-test.js, confirm
 *              route test).
 *
 * App-level intl service subclass for the e-commerce storefront.
 */
import IntlService from 'beebee-base/services/intl';

export default class Intl extends IntlService {}
